import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { wsClient } from '@/lib/ws';

const STORAGE_KEY = 'bx_aurora_opt_out';

/**
 * AuroraLayer — app-wide subtle gradient sweep that activates only when
 * a global Aurora Drift world event is currently happening. Users can
 * opt out from Profile (sets bx_aurora_opt_out=1 in localStorage).
 */
const AuroraLayer = () => {
  const [active, setActive] = useState(false);

  const optedOut = () => localStorage.getItem(STORAGE_KEY) === '1';

  useEffect(() => {
    if (optedOut()) return undefined;
    const refresh = async () => {
      try {
        const { data } = await api.get('/world/events/active');
        const hasAurora = (data.events || []).some(
          (e) => e.kind === 'aurora_drift' && new Date(e.ends_at) > new Date(),
        );
        setActive(hasAurora);
      } catch { /* */ }
    };
    refresh();
    const off = wsClient.onEvent((m) => {
      if (m?.type === 'world_event_started' || m?.type === 'world_event_ended') refresh();
    });
    const t = setInterval(refresh, 90_000);
    return () => { off(); clearInterval(t); };
  }, []);

  if (!active) return null;
  return (
    <div
      data-testid="aurora-layer"
      aria-hidden
      className="fixed inset-0 pointer-events-none z-[5] aurora-sweep"
    />
  );
};

export default AuroraLayer;
